import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/authContext";
import { ROUTES } from "./constants";

const normalizeBoolean = (value, fallback = false) => {
	if (typeof value === "boolean") return value;
	if (typeof value === "number") return value === 1;
	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		if (normalized === "true" || normalized === "1" || normalized === "yes") return true;
		if (normalized === "false" || normalized === "0" || normalized === "no") return false;
	}
	return fallback;
};

const SpecialProtectedRoute = () => {
	const { isAuthenticated, user, getOtpSessionKey } = useAuth();

	// If not authenticated at all, redirect to login
	if (!isAuthenticated) {
		return <Navigate to={ROUTES.LOGIN} replace />;
	}
	if (isAuthenticated && !user.eula_accepted) {
		console.log("User Need to Accept EULA:", !user.eula_accepted);
		return <Navigate to={ROUTES.ACCEPT_EULA} replace />;
	}

	const otpSessionKey = getOtpSessionKey(user?.user_id);
	const isVerifiedForCurrentLogin = otpSessionKey ? sessionStorage.getItem(otpSessionKey) === "true" : false;
	const backendRequiresVerification = normalizeBoolean(
		user?.requires_email_verification,
		normalizeBoolean(user?.first_login, false)
	);
	const requiresEmailVerification =
		isAuthenticated &&
		backendRequiresVerification &&
		!isVerifiedForCurrentLogin;
	// Login OTP is temporarily disabled.
	// const otpRoute = normalizeBoolean(user?.first_login, false) ? ROUTES.VERIFY_EMAIL : ROUTES.LOGIN_OTP;

	if (requiresEmailVerification) {
		return <Navigate to={ROUTES.VERIFY_EMAIL} replace />;
	}

	return <Outlet />;
};

export default SpecialProtectedRoute;
